import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { DeviationViewMode } from '../../publicSession/types';
export var loadDeviation = createAction(actionKey + ".LOAD_DEVIATION", function (deviation) { return ({ deviation: deviation }); });
export var initDeviationPage = createAction(actionKey + ".INIT_DEVIATION", function (deviation, comments) { return ({
    deviation: deviation,
    comments: comments,
}); });
export var enterZoomMode = createAction(actionKey + ".ZOOM_ENTER", function (deviation) { return ({ deviation: deviation }); });
export var exitZoomMode = createAction(actionKey + ".ZOOM_EXIT", function (deviation) { return ({ deviation: deviation }); });
export var fullscreenEntered = createAction(actionKey + ".VIEW.FULLSCREEN_ENTERED", function (deviation) { return ({ deviation: deviation }); });
export var fullscreenExited = createAction(actionKey + ".VIEW.FULLSCREEN_EXITED", function (deviation) { return ({ deviation: deviation }); });
export var togglePanel = createAction(actionKey + ".PANEL_TOGGLE", function (panelType, actionBar) { return ({
    panelType: panelType,
    actionBar: actionBar,
}); });
export var showPanel = createAction(actionKey + ".PANEL_SHOW", function (panelType, actionBar) { return ({
    panelType: panelType,
    actionBar: actionBar,
}); });
export var hidePanel = createAction(actionKey + ".PANEL_HIDE", function (panelType) { return ({ panelType: panelType }); });
export var hidePanelPopup = createAction(actionKey + ".PANEL_POPUP.HIDE", function () { return ({}); });
export var requestChangeViewMode = createAction(actionKey + ".VIEW.REQUEST_CHANGE_VIEW_MODE", function (viewMode, deviation) { return ({
    viewMode: viewMode,
    deviation: deviation,
}); });
export var requestToggleTheaterView = function (deviation) {
    return requestChangeViewMode(DeviationViewMode.Theater, deviation);
};
export var requestToggleFullscreenView = function (deviation) {
    return requestChangeViewMode(DeviationViewMode.Fullscreen, deviation);
};
export var setScreenSize = createAction(actionKey + ".VIEW.SET_SCREEN_SIZE", function (width, height) { return ({ width: width, height: height }); });
export var expandAndFocusCommentPanel = createAction(actionKey + ".EXPAND_AND_FOCUS_COMMENT_PANEL", function (deviation, actionBarType) { return ({
    deviation: deviation,
    actionBarType: actionBarType,
}); });
//# sourceMappingURL=actions.js.map